import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f2bc1ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-flex-column" }
const _hoisted_2 = { style: {"font-size":"14px","line-height":"22px","text-align":"left","font-style":"normal","text-transform":"none","margin":"16px 0 0 10px"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#697077"} }, "累计终端结算金额：", -1))
const _hoisted_4 = { style: {"color":"#121619","font-weight":"600"} }
const _hoisted_5 = { style: {"font-size":"14px","line-height":"22px","text-align":"left","font-style":"normal","text-transform":"none","margin":"16px 0 0 10px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#697077"} }, "累计终端结算金额：", -1))
const _hoisted_7 = { style: {"color":"#121619","font-weight":"600"} }

import { ref } from 'vue';
import {
  BaseTabs,
  BaseTabPane,
  XrkTable,
  XrkTableRef,
  BaseLayoutFlexContent
} from 'xrk-components';
import { projectTableColumn, personTableColumn } from '../hook/create-table';
import { projectSearchConfig, personSearchConfig } from '../hook/create-search';
import { terminalPayList } from '@/views/industry-terminal-pay/src/data-source/apis';
import { dealParam, state } from '../hook/use-event';
import { money } from 'xrk-tools';


export default /*#__PURE__*/_defineComponent({
  __name: 'industry-terminal-pay',
  setup(__props) {

const active = ref<number>(1);
const tableRenderRef = ref<XrkTableRef>(null);
const listAmount = ref<string | number>('');

const terminalPay = async params => {
  state['active'] = active;
  state['tableRenderRef'] = tableRenderRef;
  const newParam = dealParam(params);
  const data = await terminalPayList(newParam);
  listAmount.value = money.moneyFixed(data.data.remark.totalPrice || 0);
  return data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTabs), {
      modelValue: active.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseTabPane), {
          name: 2,
          label: "按项目展示"
        }),
        _createVNode(_unref(BaseTabPane), {
          name: 1,
          label: "按人展示"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(BaseLayoutFlexContent), null, {
      default: _withCtx(() => [
        (active.value === 1)
          ? (_openBlock(), _createBlock(_unref(XrkTable), {
              key: 0,
              getListAjax: terminalPay,
              "request-now": true,
              "search-config": _unref(personSearchConfig),
              tableConfig: {
          tableColumns: _unref(personTableColumn)
        },
              paginationConfig: {
          paginationPageSize: 15
        },
              ref_key: "tableRenderRef",
              ref: tableRenderRef
            }, {
              tableAfter: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("span", _hoisted_4, _toDisplayString(listAmount.value), 1)
                ])
              ]),
              _: 1
            }, 8, ["search-config", "tableConfig"]))
          : _createCommentVNode("", true),
        (active.value === 2)
          ? (_openBlock(), _createBlock(_unref(XrkTable), {
              key: 1,
              "request-now": true,
              getListAjax: terminalPay,
              "search-config": _unref(projectSearchConfig),
              tableConfig: {
          tableColumns: _unref(projectTableColumn)
        },
              paginationConfig: {
          paginationPageSize: 15
        },
              ref_key: "tableRenderRef",
              ref: tableRenderRef
            }, {
              tableAfter: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("span", _hoisted_7, _toDisplayString(listAmount.value), 1)
                ])
              ]),
              _: 1
            }, 8, ["search-config", "tableConfig"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})